import { FC, useCallback, useRef } from 'react';

export type IntersectionTestProps = {
  onChange: (isVisible: boolean) => void;
  rootMargin?: string;
};

export const IntersectionTest: FC<
  React.PropsWithChildren<IntersectionTestProps>
> = ({ onChange, rootMargin }) => {
  const intersectionObserver = useRef<IntersectionObserver | null>(null);

  const handleMount = useCallback(
    (ref: HTMLDivElement | null) => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
        intersectionObserver.current = null;
      }

      if (ref) {
        const handleIntersection: IntersectionObserverCallback = (entries) => {
          if (entries[0]) {
            onChange(entries[0].isIntersecting);
          }
        };

        intersectionObserver.current = new IntersectionObserver(
          handleIntersection,
          {
            rootMargin,
            threshold: [0, 0.001],
          }
        );

        intersectionObserver.current.observe(ref);
      }
    },
    [onChange, rootMargin]
  );

  return <div ref={handleMount} />;
};
